<template>
  <div>
    <b-row>
<!--      <b-modal id="modal-5" size="md" title="Remove Branch" hide-footer>
        <p class="font-size-18 text-black">Are you sure you want to delete this Branch? </p>
        <div class="d-flex justify-content-end">
          <b-button variant="danger" @click="deleteProject">Delete Branch</b-button>
        </div>
      </b-modal>-->
      <b-container fluid class="filter">

      <b-col lg='12'>
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">{{ $t('dashboard1.listOfUser')}}</h4>
          </template>
          <template v-slot:headerAction>
            <b-button v-if='loadingOpenAdd'  variant="primary" disabled>
              <b-spinner small type="grow"></b-spinner>
              openning...
            </b-button>
            <!--             <b-button v-else v-b-modal.modal-4 variant="primary" @click="loadData">Add Branch</b-button>
                  <b-modal id="modal-4" size="lg"  :title="modelTitle" hide-footer>
                          <add-project-modal :edit="editFlag"/>
                        </b-modal>-->
          </template>
          <template v-slot:body>
            <div v-if="loadTable" class="text-center">
              <b-spinner small type="grow"></b-spinner>
              Loading...
            </div>
            <b-table v-else striped responsive :fields="columns" :items="allUsers" class="mb-0 table-borderless">
              <template v-slot:cell(img_id)="data">
                <a :href="data.item.img_id" target="_blank"><b-button variant=" iq-bg-success mr-1 mb-1" size="sm" ><i class="las la-photo-video"></i></b-button></a>
              </template>
              <template v-slot:cell(cv)="data">
                <a :href="data.item.cv" target="_blank"><b-button variant=" iq-bg-primary mr-1 mb-1" size="sm" ><i class="las la-file-image"></i></b-button></a>
              </template>
              <template v-slot:cell(confirmation_img)="data">
                <a :href="data.item.confirmation_img" target="_blank"><b-button variant=" iq-bg-success mr-1 mb-1" size="sm" ><i class="las la-photo-video"></i></b-button></a>
              </template>
<!--              <template v-slot:cell(actions)>
                <b-button variant=" iq-bg-danger" size="sm" ><i class="ri-delete-bin-line m-0"  ></i></b-button>
              </template>-->
            </b-table>
<!--            <b-pagination v-model="currentPage"
                          class="mt-3"
                          :total-rows="total"
                          align="right"
                          :per-page="per_page"
                          aria-controls="my-table"
                          @input="changeContent"
            ></b-pagination>-->
          </template>
        </iq-card>
      </b-col>
      </b-container>
    </b-row>
  </div>
</template>
<script>
import { core } from '../../../config/pluginInit'

export default {
  name: 'users',
  data () {
    return {
      allUsers: [],
      loadTable: true,
      columns: [
        { label: 'Name', key: 'user_name', class: 'text-center' },
        { label: 'Nationality', key: 'nationality', class: 'text-center' },
        { label: 'Country', key: 'country', class: 'text-center' },
        { label: 'Phone', key: 'phone', class: 'text-center' },
        { label: 'National Id', key: 'national_id', class: 'text-center' },
        { label: 'Email', key: 'email', class: 'text-center' },
        { label: 'ticket type', key: 'type_of_share', class: 'text-center' },
        { label: 'ID', key: 'img_id', class: 'text-center' },
        { label: 'CV', key: 'cv', class: 'text-center' },
        { label: 'Confirmation', key: 'confirmation_img', class: 'text-center' }
      ]
    }
  },
  mounted () {
    core.index()
  },
  created () {
    this.$store.dispatch('getAllUsers').then(response => {
      console.log(response.data)
      this.allUsers = response.data
      this.loadTable = false
    })
  }
}
</script>
